import actionCreatorFactory from "typescript-fsa";
import { bindThunkAction } from "typescript-fsa-redux-thunk";

import { RootState } from "../../state";
import { UnknownError } from "../../common/actions/VisitApi";
import { isFailure } from "../../common/actions/VisitApi";
import { requestToCreatePostLike, requestToDeletePostLike } from "../api";
import { isLikedSelector } from "../selectors";

const actionCreator = actionCreatorFactory("POST_LIKES");

export const postLikeClicked = actionCreator.async<RootState, number, null, UnknownError>("CLICKED");
export const postLikeClickedWorker = bindThunkAction(postLikeClicked, async (postId, dispatch, getState) => {
  const newStatus = isLikedSelector(getState(), postId); // Already toggled at `started` action
  const req = newStatus ? requestToCreatePostLike(postId) : requestToDeletePostLike(postId);
  const res = await dispatch(req);
  if (isFailure(res)) {
    throw res.payload.body;
  }
  return null;
});



// WEBPACK FOOTER //
// ./frontend/src/post_likes/actions/index.ts